import * as usuariosApi from "../api/usuarios";

// Cor da turma (a "bolinha") é por usuário e sincronizada entre dispositivos:
// a fonte da verdade é o backend. Mantemos um espelho em localStorage
// (chave `turma_cor:<turmaId>`) para leitura síncrona barata em toda a UI
// (corDaTurma), populado ao logar e atualizado ao trocar a cor.
export const COR_TURMA_FALLBACK = "#76A8D9";

// Paleta padrão. Sem cor escolhida, a turma recebe uma cor DETERMINÍSTICA a
// partir do seu id — assim a "bolinha" fica igual em todos os dispositivos sem
// precisar gravar nada (antes era aleatória por dispositivo, causando divergência).
const PALETA_TURMAS = [
  "#3B82F6",
  "#22C55E",
  "#A855F7",
  "#F59E0B",
  "#EF4444",
  "#14B8A6",
  "#8B5CF6",
  "#84CC16",
  "#06B6D4",
  "#EC4899",
  "#6366F1",
  "#F97316",
];

function chave(turmaId) {
  return `turma_cor:${turmaId}`;
}

function corPadrao(turmaId) {
  const s = String(turmaId);
  let h = 0;
  for (let i = 0; i < s.length; i++) h = (h * 31 + s.charCodeAt(i)) >>> 0;
  return PALETA_TURMAS[h % PALETA_TURMAS.length];
}

export function corDaTurma(turmaId) {
  if (!turmaId) return COR_TURMA_FALLBACK;
  return localStorage.getItem(chave(turmaId)) || corPadrao(turmaId);
}

// Baixa as cores do backend e espelha no localStorage. Chamado ao logar/recarregar
// o usuário, garantindo a mesma cor em qualquer dispositivo.
export async function sincronizarCoresTurma() {
  try {
    const cores = await usuariosApi.listarCoresTurmas();
    if (!Array.isArray(cores)) return;

    const doBackend = new Set();
    cores.forEach((c) => {
      if (c?.turmaId && c?.cor) {
        doBackend.add(String(c.turmaId));
        localStorage.setItem(chave(c.turmaId), c.cor);
      }
    });

    // Remove cores locais antigas (aleatórias por dispositivo) que o backend não
    // tem: assim turmas sem cor escolhida caem no default determinístico, igual
    // em todos os dispositivos. O backend é a única fonte de cores explícitas.
    for (let i = localStorage.length - 1; i >= 0; i--) {
      const k = localStorage.key(i);
      if (k && k.startsWith("turma_cor:") && !doBackend.has(k.slice(10))) {
        localStorage.removeItem(k);
      }
    }

    window.dispatchEvent(new Event("app:data-changed"));
  } catch {
    // sem rede/sessão: mantém o que já houver em localStorage
  }
}

// Salva a cor escolhida: espelha local na hora (UI responde) e persiste no
// backend para os outros dispositivos.
export function salvarCorTurma(turmaId, cor) {
  if (!turmaId || !cor) return;
  localStorage.setItem(chave(turmaId), cor);
  window.dispatchEvent(new Event("app:data-changed"));
  usuariosApi.definirCorTurma(turmaId, cor).catch(() => {
    // falha de rede não trava a UI; a cor local vale até o próximo sync
  });
}
